import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const AppetiteStepper = ({ steps }) => {
  const [searchParams] = useSearchParams();

  const screenFromUrl = searchParams.get("currentScreen");

  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    if (screenFromUrl === 'StartApplication') {
      setCurrentStep(1);
    } else{
      setCurrentStep(0);
    }
  }, [screenFromUrl]);

  return (
    <div className="flex flex-col space-y-2 mt-4">
      {steps.map((step, index) => (
        <div key={index} className="flex items-start space-x-[6px]">
          {/* Step Number */}
          <div className="flex flex-col items-center">
            <div
              className={`w-5 h-5 text-[13px] rounded-full flex items-center justify-center font-bold ${
                index === currentStep
                  ? "bg-blue-500 text-white"
                  : "bg-[#ECEFF2] text-[#5B616B]"
              }`}
            >
              {index + 1}
            </div>
            {index < steps.length - 1 && (
              <div
                className={`${index === 0 ? "h-[48px]" : "h-[16px]"} mt-1 border-l-2 border-dotted border-[#9097A1]`}
              ></div>
            )}
          </div>

          {/* Step Content */}
          <div className="space-y-2">
            <h2 className={`text-[14px]  'text-[#39404B] mt-[2px]`}>
              {step.title}
            </h2>
            {step.subSteps && (
              <div className="flex flex-col space-y-3 ml-3 mt-2">
                {step.subSteps.map((subStep, subIndex) => (
                  <div
                    key={subIndex}
                    className="text-[13px]"
                    style={{
                      color: subStep.slug.includes(screenFromUrl)
                        ? "#3581E3"
                        : "#9097A1"
                    }}
                  >
                    {subStep.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AppetiteStepper;
